/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Dl_Web_3Inputs */

const en_pc_dl_web_3 = /** @type {(inputs: Pc_Dl_Web_3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serve .wasm as application/wasm and turn on gzip or Brotli. It matters: the ${i?.version} .wasm is 38 MB uncompressed and about 13 MB with Brotli, as measured on our hosted copy.`)
};

const zh_pc_dl_web_3 = /** @type {(inputs: Pc_Dl_Web_3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`以 application/wasm 类型提供 .wasm，并开启 gzip 或 Brotli 压缩。这一点很重要：${i?.version} 版的 .wasm 未压缩时为 38 MB，Brotli 压缩后约 13 MB（在本站托管的副本上实测）。`)
};

/**
* | output |
* | --- |
* | "Serve .wasm as application/wasm and turn on gzip or Brotli. It matters: the {version} .wasm is 38 MB uncompressed and about 13 MB with Brotli, as measured on..." |
*
* @param {Pc_Dl_Web_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_web_3 = /** @type {((inputs: Pc_Dl_Web_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Web_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_web_3(inputs)
	return zh_pc_dl_web_3(inputs)
});
export { pc_dl_web_3 as "pc.dl.web.3" }